import { IconComponent } from 'models/icons';

/**
 * This file was auto-generated using svgr
 *
 * Source file: assets/icons/type-group.svg
 */
const IconTypeGroup: IconComponent = ({
  size = 24,
  color = 'white',
  className,
  svgElementProps: props = {},
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    color={color}
    className={className}
    {...props}
  >
    <path
      d="M11.874 13.019l-4.984-2.86a1.304 1.304 0 00-1.272 0l-4.984 2.86A1.255 1.255 0 000 14.123v5.734a1.302 1.302 0 00.634 1.104l4.984 2.86a1.234 1.234 0 001.272 0l4.984-2.873a1.257 1.257 0 00.634-1.104v-5.721a1.285 1.285 0 00-.634-1.104zM6.122 11.01a.22.22 0 01.134-.03c.045.003.09.012.131.03l4.597 2.653-4.728 2.713-4.732-2.713 4.598-2.653zm-4.97 9.05a.27.27 0 01-.132-.22v-5.306l4.733 2.726v5.44l-4.602-2.64zm10.205 0l-4.601 2.653v-5.453l4.732-2.726v5.293a.272.272 0 01-.131.217v.016z"
      fill="currentColor"
    />
    <path
      d="M23.362 13.019l-4.984-2.86a1.303 1.303 0 00-1.272 0l-4.98 2.86a1.258 1.258 0 00-.638 1.104v5.734a1.295 1.295 0 00.638 1.104l4.98 2.86a1.215 1.215 0 001.272 0l4.984-2.873A1.26 1.26 0 0024 19.844v-5.721a1.286 1.286 0 00-.638-1.104zM17.61 11.01a.229.229 0 01.134-.03c.046.003.091.012.134.03l4.598 2.653-4.732 2.713-4.732-2.713 4.598-2.653zm-4.967 9.05a.273.273 0 01-.135-.217v-5.31l4.732 2.727v5.44l-4.597-2.64zm10.203 0l-4.599 2.653v-5.453l4.732-2.726v5.293a.273.273 0 01-.13.217l-.003.016z"
      fill="currentColor"
    />
    <path
      d="M17.533 3.026L12.549.165a1.304 1.304 0 00-1.272 0l-4.984 2.86a1.255 1.255 0 00-.634 1.105v5.734a1.308 1.308 0 00.634 1.108l4.984 2.857a1.234 1.234 0 001.272 0l4.984-2.874a1.262 1.262 0 00.634-1.104V4.13a1.288 1.288 0 00-.634-1.104zM11.78 1.018a.212.212 0 01.131-.03.477.477 0 01.135.03l4.597 2.653-4.732 2.713-4.73-2.713 4.599-2.653zm-4.97 9.05a.272.272 0 01-.131-.22V4.542l4.732 2.726v5.44l-4.601-2.64zm10.206 0l-4.602 2.653V7.268l4.732-2.726v5.293a.257.257 0 01-.13.25v-.017z"
      fill="currentColor"
    />
  </svg>
);

export default IconTypeGroup;
